/* eslint-disable no-barrel-files/no-barrel-files */
/**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */

export type {
	SiteInformationQuery$data as SiteInformationQuery,
	SiteInformationQuery$variables as SiteInformationQueryVariables,
} from '../__generated__/SiteInformationQuery.graphql.ts';

// Nested types extracted from Relay-generated types
import type { SiteInformationQuery$data } from '../__generated__/SiteInformationQuery.graphql.ts';
export type SiteInformationQuery_tenant_Tenant = NonNullable<SiteInformationQuery$data['tenant']>;
export type SiteInformationQuery_organization_Organization = NonNullable<SiteInformationQuery$data['organization']>;
export type SiteInformationQuery_userForAnalytics_AtlassianUser = NonNullable<SiteInformationQuery$data['userForAnalytics']>;
export type SiteInformationQuery_user_AtlassianUser_confluence_ConfluenceUser = NonNullable<NonNullable<SiteInformationQuery$data['user']>['confluence']>;
export type SiteInformationQuery_user_AtlassianUser = NonNullable<SiteInformationQuery$data['user']>;
export type SiteInformationQuery_getAIConfig_AIConfigResponse = NonNullable<SiteInformationQuery$data['getAIConfig']>;
export type SiteInformationQuery_confluence_tenantContext_ConfluenceTenantContext_licenseStates_LicenseStates_confluence_LicenseState = NonNullable<NonNullable<NonNullable<SiteInformationQuery$data['confluence_tenantContext']>['licenseStates']>['confluence']>;
export type SiteInformationQuery_confluence_tenantContext_ConfluenceTenantContext_licenseStates_LicenseStates = NonNullable<NonNullable<SiteInformationQuery$data['confluence_tenantContext']>['licenseStates']>;
export type SiteInformationQuery_confluence_tenantContext_ConfluenceTenantContext_editions_Editions = NonNullable<SiteInformationQuery$data['confluence_tenantContext']>['editions'];
export type SiteInformationQuery_confluence_tenantContext_ConfluenceTenantContext = NonNullable<SiteInformationQuery$data['confluence_tenantContext']>;
export type SiteInformationQuery_siteSettings_SiteSettings_homepage_Homepage = NonNullable<NonNullable<SiteInformationQuery$data['siteSettings']>['homepage']>;
export type SiteInformationQuery_siteSettings_SiteSettings_frontCover_FrontCover = NonNullable<NonNullable<SiteInformationQuery$data['siteSettings']>['frontCover']>;
export type SiteInformationQuery_siteSettings_SiteSettings = NonNullable<SiteInformationQuery$data['siteSettings']>;
export type SiteInformationQuery_siteDescription_SiteDescription = NonNullable<SiteInformationQuery$data['siteDescription']>;
export type SiteInformationQuery_currentConfluenceUser_CurrentConfluenceUser = NonNullable<SiteInformationQuery$data['currentConfluenceUser']>;

// GraphQL enums (preserved from original file)
// ⚠️  DEPRECATION WARNING: Prefer using Relay's generated union string types instead of enums.
// Relay generates more type-safe union types (e.g., "DRAFT" | "PUBLISHED" | "ARCHIVED")
// instead of enums. These enums are kept for backward compatibility only.
export enum AccessStatus {
  ANONYMOUS_ACCESS = "ANONYMOUS_ACCESS",
  EXTERNAL_COLLABORATOR_ACCESS = "EXTERNAL_COLLABORATOR_ACCESS",
  EXTERNAL_SHARE_ACCESS = "EXTERNAL_SHARE_ACCESS",
  LICENSED_ADMIN_ACCESS = "LICENSED_ADMIN_ACCESS",
  LICENSED_USE_ACCESS = "LICENSED_USE_ACCESS",
  NOT_PERMITTED = "NOT_PERMITTED",
  UNLICENSED_AUTHENTICATED_ACCESS = "UNLICENSED_AUTHENTICATED_ACCESS",
}

export enum ConfluenceEdition {
  FREE = "FREE",
  PREMIUM = "PREMIUM",
  STANDARD = "STANDARD",
}

export enum Environment {
  DEVELOPMENT = "DEVELOPMENT",
  PRODUCTION = "PRODUCTION",
  STAGING = "STAGING",
}

